import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStaffService } from '@core/services/auth-staff.service';
import { catchError, of } from 'rxjs';

export const canActivateAuthStaff: CanActivateFn = () => {
  
  const authService = inject(AuthStaffService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/sign-in']);
    return false;
  }

  return authService.canActivate().pipe(
    catchError(() => {
      router.navigate(['/sign-in']);
      return of(false);
    })
  );
};
